
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component
export default class PiOrderEchart extends Vue {
  @Prop({
    default: () => {
      return "";
    }
  })
  private title!: string;
  private detailEchart: objAny = {};
  private myChart: objAny = {};
  private win: objAny = window;

  private chartData: objAny = {
    value: [],
    time: []
  };

  async init(chartData: objAny): Promise<void> {
    this.chartData = chartData;
    this.echartShow();
  }
  public echartShow(): void {
    const option = {
      // title: {
      //   text: "充电站数据统计",
      //   left: "center"
      // },
      color: [this.chartData.color],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: this.chartData.time,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          // name: this.title,
          type: "value"
        }
      ],
      series: [
        {
          name: this.title,
          type: this.chartData.type,
          barWidth: "60%",
          data: this.chartData.value
        }
      ]
    };
    this.myChart = this.win.echarts.init(this.detailEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }

  mounted() {
    this.$nextTick(() => {
      this.detailEchart = this.$refs["detailEchart"];
    });
  }
}
